import type { IStatusProps } from 'shared/ui/Status'

const retryStatus: IStatusProps = {
  title: 'Retry',
  icon: 'closeCircle',
  emphasis: 'high',
  intent: 'negative',
}

export const creditUsageStatusConfig: Record<string, IStatusProps> = {
  delivered: {
    title: 'Delivered',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  received: {
    title: 'Received',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  completed: {
    title: 'Completed',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  'no-answer': {
    title: 'No-Answer',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  undelivered: {
    title: 'Undelivered',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  queued: {
    title: 'Queued',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  busy: {
    title: 'Busy',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  failed: {
    title: 'Failed',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  retry: retryStatus,
  retry_manual: retryStatus,
  read: {
    title: 'Read',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  sent: {
    title: 'Sent',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
}
